<template>
  <div id="app">
    <head-Back title="设置"></head-Back>
    <div class="page">
      <div class="page-title">如何解决“手机收不到消息”</div>
      <div class="page-shou">
        <b>首先，以下方法可以解决90%的问题</b>

        <p class="page-shou-t">1、将手机系统升级至最新版本</p>
        <p class="page-shou-desc">
          苹果手机：【设置】→【通用】→【软件更新】
          <br />安卓手机：【设置】→【软件更新】
        </p>
        <br />
        <p class="page-shou-t">2、卸载，重装最新版本</p>
        <!-- <p class="page-shou-desc">
          去官网
          <a>www.haoyunba.com</a> 下载最新版本
        </p> -->
      </div>
      <div class="page-n">若以上操作不能解决问题，请参考下文</div>

      <div class="page-shou page-m">
        <b>收不到信息时，进行以下操作：</b>
        <p class="age-shou-a text-color">1、APP内，消息通知【打开】</p>
        <div class="page-toapp">
          <div class="page-toapp-left">本APP内的设置</div>
          <div class="page-toapp-right" @click="toalocal">
            <img src="./img/toright.png" alt />
          </div>
        </div>
        <div class="border-div"></div>

        <p class="age-shou-a text-color">2、手机，消息通知【打开】</p>
        <div class="page-toapp">
          <div class="page-toapp-left">
            打开
            <a>苹果手机</a> 的设置
          </div>
          <div class="page-toapp-right" @click="toaapple" >
            <img src="./img/toright.png" alt />
          </div>
        </div>
        <div class="border-div"></div>

        <div class="page-t">打开安卓手机的设置</div>
        <div class="border-div"></div>

       <div class="page-toapp">
          <div class="page-toapp-left">
            <a>华为手机</a>
          </div>
          <div class="page-toapp-right"  @click="toahw" >
            <img src="./img/toright.png" alt />
          </div>
        </div>
                <div class="border-div"></div>

          <div class="page-toapp">
          <div class="page-toapp-left">
            <a>小米手机</a>
          </div>
          <div class="page-toapp-right"   @click="tomi" >
            <img src="./img/toright.png" alt />
          </div>
        </div>
        <div class="border-div"></div>

          <div class="page-toapp">
          <div class="page-toapp-left">
            <a>OPPO手机</a>
          </div>
          <div class="page-toapp-right"  @click="tooppo"  >
            <img src="./img/toright.png" alt />
          </div>
        </div>
        <div class="border-div"></div>

          <div class="page-toapp">
          <div class="page-toapp-left">
            <a>VIVO手机</a>
          </div>
          <div class="page-toapp-right"  @click="tovivo" >
            <img src="./img/toright.png" alt />
          </div>
        </div>
        
      
      </div>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back-close";

export default {
  metaInfo: {
    title: "设置"
  },
  name: "app",
  data() {
    return {
      msg: "设置"
    };
  },
  methods:{
      toalocal(){
          this.$router.push("/app/setting/local");
      },
       toaapple(){
          this.$router.push("/app/setting/apple");
      },
      toahw(){
          this.$router.push("/app/setting/hw");
      },
      tomi(){
          this.$router.push("/app/setting/mi");
      },
      tooppo(){
          this.$router.push("/app/setting/oppo");
      },
       tovivo(){
          this.$router.push("/app/setting/vivo");
      },
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: auto;
}
.page {
  width: 690px;
  height: auto;
  margin: 30px auto 0 auto;
}
.page-title {
  width: 100%;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 44px;
  color: #0064ff;
  opacity: 1;
  text-align: center;
}
.page-shou {
  width: 630px;
  height: 440px;
  background: #fafafa;
  opacity: 1;
  border-radius: 10px;
  margin: 30px auto 0 auto;
  text-align: left;
  padding: 30px;
}
.page-shou b {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 60px;
  color: #333333;
  opacity: 1;
}

.page-shou a {
  color: #0064ff;
}

.page-shou-t {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 10px;
  color: #333333;
  opacity: 1;
}

.page-shou-desc {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 60px;
  color: #666666;
  opacity: 1;
}

.page-n {
  width: 100%;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 34px;
  color: #999999;
  opacity: 1;
  margin: 30px auto 0 auto;
}

.page-m{
  height: 925px;
  margin: 30px auto 100px auto;
}
.page-shou-a {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 44px;
  color: #333333;
  opacity: 1;
}
.page-toapp {
  width: 100%;
  height: 40px;
  margin: 30px auto 30px auto;
}
.page-toapp-left {
  float: left;
  width: 304px;
  height: 40px;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 40px;
  color: #666666;
  opacity: 1;
}

.page-toapp-right {
  float: right;
  width: 16px;
  height: 28px;
  margin-top: 10px;
}

.page-toapp-right img {
  height: 100%;
  width: 100%;
}

.text-color {
  background: #fafafa;
  opacity: 1;
  border-radius: 10px;
}
.border-div {
  width: 630px;
  height: 0px;
  border: 1px solid #eeeeee;
  opacity: 1;
  margin: 30px auto 0 auto;
}
.page-toapp-left a {
  color: #0064ff;
}
.page-t {
  width: 100%;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 80px;
  color: #666666;
  opacity: 1;
  height: 80px;
  margin: 30px auto 30px auto;

}
</style>


// WEBPACK FOOTER //
// src/components/clac/setting.vue